import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { VisibilityOff, RemoveRedEye } from '@material-ui/icons';
import { isType, flattenChildren } from '../../../../utils/react-children-utils/react-children-utils';
import { PASSWORD_ERROR } from './utils';
import styles from './styles.scss';

/// This is a wrapper around an <input> that enables show/hide for passwords
const PasswordInput = function PasswordInput({
    validation, shouldvalidate, invalidclass, children,
}) {
    const [showPassword, setShowPassword] = useState(false);

    const validatePassword = (event) => {
        if (!shouldvalidate || !validation) {
            // no point in validating if these two aren't here
            return;
        }

        const { value } = event.target;

        if (value.length < 9) {
            validation(event, PASSWORD_ERROR.TOO_SHORT);

            return;
        }

        if (!/[A-z]/.test(value) || !/[0-9]/.test(value)) {
            validation(event, PASSWORD_ERROR.MISSING_REQUIRED_CHARACTERS);

            return;
        }

        validation(event, '');
    };

    const input = flattenChildren(children).find((c) => isType(c, 'input'));

    return (
        <div className={cx('control', 'has-icons-right', styles['password-input'])}>
            <input
                {...input.props}
                className={`${input.props.className} ${invalidclass}`}
                type={showPassword ? 'text' : 'password'}
                onInput={(shouldvalidate && validation) ? validatePassword : undefined}
                data-testid={`${input.props.name}-input`}
            />
            <span
                role="button"
                tabIndex={0}
                className={cx('icon', 'is-small', 'is-right', styles['input-icon'], styles['show-password-icon'])}
                onClick={() => setShowPassword((prev) => !prev)}
            >
                {showPassword ? <RemoveRedEye /> : <VisibilityOff />}
            </span>
        </div>
    );
};

PasswordInput.propTypes = {
    children: PropTypes.node.isRequired,
    validation: PropTypes.func,
    shouldvalidate: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
    ]),
    invalidclass: PropTypes.string,
};

PasswordInput.defaultProps = {
    validation: () => { },
    shouldvalidate: false,
    invalidclass: '',
};

export default PasswordInput;
